/*
 * FOOTER
 */
import React from 'react';
import { useEffect } from 'react';
import CTA from '@/components/shared/CTA';
import Menu from '@/components/shared/Menu';
import '@/styles/components/feedback.scss';
import '@/styles/components/footer.scss';

// Year
const footerDate: Date = new Date();
const footerYear: number = footerDate.getFullYear();

const Footer: React.FC = () => {
    useEffect( () => {
        // Add newsletter signup form embed (renders its iframe directly after the script tag)
        const signupWrapper: HTMLElement | null = document.getElementById( 'signup-inner-wrapper' );
        if ( signupWrapper && !signupWrapper.querySelector( 'script[data-form-id]' ) ) {
            const signupScript = document.createElement( 'script' );
            signupScript.setAttribute( 'src', 'https://astraeafoundation.ddockforms.com/assets/js/embed.js' );
            signupScript.setAttribute( 'data-form-id', '06844b2e-1edd-4d2e-a266-040a1567cd70' );
            signupScript.async = true;
            signupWrapper.appendChild( signupScript );
        }
        const signupBtn = document.getElementById( 'footer-cta' );
        if ( signupBtn ) {
            signupBtn.addEventListener( 'click', function( e ) {
                e.preventDefault();
                const signupAside = document.getElementById( 'newsletter-signup' );
                if ( signupAside ) {
                    signupAside.classList.add( 'open' );
                }
            } );
        }
        const signupClose = document.getElementById( 'signup-close' );
        if ( signupClose ) {
            signupClose.addEventListener( 'click', function( e ) {
                e.preventDefault();
                const signupAside = document.getElementById( 'newsletter-signup' );
                if ( signupAside ) {
                    signupAside.classList.remove( 'open' );
                }
            } );
        }
    }, [] );
    return(
        <>
        <footer id="af-footer">
            <section id="af-footer-top">
                <div className="container">
                    <Menu name="footer-nav" />
                    <CTA url="#" modal={ false } id="footer-cta"><span>Sign Up for Our Newsletter</span></CTA>
                </div>
            </section>
            <section id="af-footer-bottom">
                <div className="container">
                    <p className="footer-address">Astraea Foundation &bull; 1216 Broadway, 2nd Floor, #1019, New York, NY 10001 &bull; Phone +1 (212) 529-8021</p>
                    <p className="footer-year">© { footerYear } Astraea Lesbian Foundation for Justice. All Rights Reserved.<br /> Astraea Foundation, Inc. is a 501(c)(3). All donations are tax deductible. EIN #13-2992977</p>
                </div>        
            </section>
            { /* TODO: Cookie Consent */ }
        </footer>
        <aside id="newsletter-signup">
            <button id="signup-close"><span>Close</span></button>
            <div id="signup-inner-wrapper"></div>
        </aside>
        </>
    );
};
export default Footer;